import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import Checkbox from '@material-ui/core/Checkbox';
import MinimalSelect from '../../ui/MinimalSelect';
import { CheckboxField, Field, TextField } from '../UI';
import { TextPart } from './TextPart';
import EditorContext from '../../../modules/contexts/editor';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import { colorChoices } from '../../../modules/defines/style';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import DuplicateIcon from '@material-ui/icons/FileCopyOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import deepClone from 'deep-clone';
import httpAPI from '@mirinae/lessons/editor/modules/apis/http';
import { apiPaths } from '@mirinae/defines/paths';
import Button from '@material-ui/core/Button';
import TextInput from '@mirinae/lessons/editor/components/ui/TextInput';

const BoxWrapper = styled.div`
`;

const PartsBox = styled.div`
    border: thin solid lightgray;
    border-radius: 4px;
    margin-left: 6px;
`;

const Label = styled.div`
    margin: 6px 4px;
`;

const PartsWrapper = styled(Field)`
    display: table;
    margin-left: 5px;
`;
const PartTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    font-weight: bold;
    padding: 0 4px;
    background-color: #ececec;
`;
const PartRow = styled.div`
    display: table-row;
    flex-direction: row;
`;
const PartField = styled.div`
    display: table-cell;
    max-width: min-content;
    position: relative;
`;
const Value = styled(TextField)`
    // padding-right: 10px;
`;
const ColorSelect = styled(MinimalSelect)`
    width: 70px;
`;
const Underline = styled(Checkbox)`
    width: 11px;
    height: 0px;
    color: #9a9a9a !important;
`;
const AddPart = styled.div`
    font-weight: bold;
    //border: thin solid #ababab;
    //border-radius: 50%;
    cursor: pointer;
    margin: 0 0 6px 4px;
    width: 17px;
    height: 17px;
    text-align: center;
    font-size: 16px;
    background-color: #ffffff;
`;

const TextRow = styled.div`
    display: flex;
    align-self: flex-end;
`;

const ToolsPopup = styled.div`
    position: absolute;
    
`;

const ToolButton = styled.span`
    cursor: ${props => (props.disable ? 'inherit' : 'pointer')};
    color: ${props => (props.disable ? '#bbb' : '#6a6a6a')};
`;

const GraphicWrapper = styled.div`
`;

const URLInput = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    
    & span {
        margin: 12px;
    }
    
    & input {
        border: none;
        border-bottom: solid thin gray;
        width: 350px;
    }
`;

export const Parts = ({ node, field, label }) => {
    const editor = useContext(EditorContext);
    const global = useContext(GlobalContext);
    const editCommands = false; // I think the only time we need commands is in pattern-anim and that is now handled in the animation editor??

    const GraphicUpload = ({ pn, i }) => {

        const selectGraphic = (e) => {
            const inputForm = document.getElementById('image-upload-form-id');
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            inputForm.appendChild(input);

            const updloadGraphic = () => {
                const file = input.files[0];
                let data = new FormData();
                data.append('file', file, field.name);

                httpAPI('', apiPaths.graphicUpload, {
                    data,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }}
                ).then((response) => {
                    console.log(response);
                    const { url, mimetype } = response;
                    editor.updateElementFieldPart(node, field, pn, i, 'url', url);
                    editor.updateElementFieldPart(node, field, pn, i, 'mimeType', mimetype);
                    editor.commitNodeUpdate(node);
                 }).catch((error) => {
                    console.log(error);
                });
            };

            input.addEventListener('change', updloadGraphic);
            input.click();
        };

        const urlChanged = (e) => {
            editor.updateElementFieldPart(node, field, pn, i, 'url', e.target.value);
            editor.updateElementFieldPart(node, field, pn, i, 'mimeType', 'image/*');
            editor.commitNodeUpdate(node);
        };

        return (
            <GraphicWrapper>
                <URLInput><span>URL:</span><input type="text" defaultValue={field.parts[pn][i].url} onBlur={urlChanged}/></URLInput>
                <Button
                    variant="outlined" size="small" style={{ margin: '6px 110px 12px 142px' }}
                    onClick={selectGraphic}
                >
                    Upload {field.label} graphic
                </Button>
            </GraphicWrapper>
        );
    };


    const subfieldChanged = (pn, i, subfield, value) => {
        editor.updateElementFieldPart(node, field, pn, i, subfield, value);
        if (subfield === 'color' && value.match(/separate|merge|space/)) // mild hack to clear value if one of the meta colors is used
            editor.updateElementFieldPart(node, field, pn, i, 'value', '');
        editor.commitNodeUpdate(node);
        if (field.example) global.update({ playerUpdateTrigger: global.playerUpdateTrigger + 1 });
    };

    const addRow = (e, pn) => {
        const newParts = [...field.parts[pn]];
        newParts.push({ value: '-word-', color: 'example', underline: false });
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
        if (field.example) global.update({ playerUpdateTrigger: global.playerUpdateTrigger + 1 });
    };

    const deleteRow = (e, pn, i, p) => {
        const newParts = [...field.parts[pn]];
        newParts.splice(i, 1);
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
        if (field.example) global.update({ playerUpdateTrigger: global.playerUpdateTrigger + 1 });
    };

    const duplicateRow = (e, pn, i, p) => {
        const newParts = [...field.parts[pn]];
        newParts.splice(i + 1, 0, deepClone(p));
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
        if (field.example) global.update({ playerUpdateTrigger: global.playerUpdateTrigger + 1 });
    };

    const enableDisable = (e, pn) => {
        if (e.target.checked) {
            if (!field.hiddenParts)
                field.hiddenParts = [];
            field.hiddenParts.push(pn);
        } else if (field.hiddenParts && field.hiddenParts.includes(pn)) {
            field.hiddenParts.splice(field.hiddenParts.indexOf(pn), 1);
        }
        editor.updateElementField(node, field, 'hiddenParts', field.hiddenParts);
        editor.commitNodeUpdate(node);
    };

    const isTextParts = (pn) => field.parts[pn].some(p => p.hasOwnProperty('styles'));
    const isGraphicsParts = (pn) => field.parts[pn].some(p => p.hasOwnProperty('url'));

    const fieldEdit = (edit) => node.fieldEdits && node.fieldEdits.includes(edit);

    const addTextRow = (e, pn ) => {
        const newParts = [...field.parts[pn]];
        newParts.push({ value: '-text-', styles: [], links: [] });
        editor.updateElementFieldParts(node, field, pn, newParts);
        editor.commitNodeUpdate(node);
    };

    return (
        <BoxWrapper>
            { label && <Label>{label}</Label> }
            <PartsBox>
                { Object.getOwnPropertyNames(field.parts).map(pn =>
                    <div key={pn}>
                        <PartTitle>
                            {`${pn.charAt(0).toUpperCase()}${pn.slice(1)}`}
                            { !field.example && !fieldEdit('noHide') &&
                                <CheckboxField label="Hide" checked={Boolean(field.hiddenParts) && field.hiddenParts.includes(pn)} onChange={e => enableDisable(e, pn)} /> }
                        </PartTitle>
                        { !(field.hiddenParts && field.hiddenParts.includes(pn)) && open && (
                            isTextParts(pn) ? (
                                <>
                                    { field.parts[pn].map((p, i) => (
                                        <TextRow key={i} >
                                            <TextPart node={node} field={field} pn={pn} i={i} />
                                            { field.parts[pn].length > 1 && <ToolButton onClick={e => deleteRow(e, pn, i, p)}><DeleteIcon /></ToolButton> }
                                        </TextRow>
                                    ))}
                                    <AddPart onClick={e => addTextRow(e, pn)}><AddCircleOutlineIcon /></AddPart>
                                </>
                            ) : isGraphicsParts(pn) ? (
                                <GraphicUpload pn={pn} i={0} />
                            ) : (
                                <PartsWrapper>
                                    <PartRow>
                                        <PartField style={{ paddingLeft: 20 }}>Text</PartField>
                                        { !fieldEdit('noColor') && <PartField>Color</PartField> }
                                        { fieldEdit('commands') && <PartField>Commands</PartField> }
                                        { field.type === 'underlinedParts' && <PartField>U-line</PartField> }
                                        { field.type === 'shortenedParts' && <PartField>Shortened</PartField> }
                                    </PartRow>
                                    { field.parts[pn].map(p => editor.repairColor(p)).map((p, i) =>
                                        <PartRow key={`${pn}-${i}`}>
                                            <PartField style={{width: '100%'}}><Value inputRef={input => { if (input) input.value = p.value; }} onBlur={e => subfieldChanged(pn, i, 'value', e.target.value)} /></PartField>
                                            { !fieldEdit('noColor') && <PartField style={{width: 75}}><ColorSelect options={colorChoices} value={p.color} onSelect={e => subfieldChanged(pn, i, 'color', e.target.value)} placeHolder="-- color --" /></PartField> }
                                            { fieldEdit('commands') && <PartField><Value inputRef={input => { if (input) input.value = p.command || ''; }} onBlur={e => subfieldChanged(pn, i, 'command', e.target.value)} /></PartField> }
                                            { field.type === 'underlinedParts'  && <PartField style={{width: 35}}><Underline size='small' checked={p.underline || false} onChange={e => subfieldChanged(pn, i, 'underline', e.target.checked)} /></PartField> }
                                            { field.type === 'shortenedParts' && <PartField style={{width: 35}}><Underline size='small' checked={p.shortened || false} onChange={e => subfieldChanged(pn, i, 'shortened', e.target.checked)} /></PartField> }
                                            <PartField style={{ minWidth: 42 }}>
                                                <ToolButton onClick={e => duplicateRow(e, pn, i, p)}><DuplicateIcon /></ToolButton>
                                                { field.parts[pn].length > 1 && <ToolButton onClick={e => deleteRow(e, pn, i, p)}><DeleteIcon /></ToolButton> }
                                            </PartField>
                                        </PartRow>
                                    )}
                                    { !fieldEdit('noPartAdd') && <AddPart onClick={e => addRow(e, pn)}><AddCircleOutlineIcon /></AddPart> }
                                </PartsWrapper>
                            )
                        )}
                    </div>
                )}
            </PartsBox>
        </BoxWrapper>
    );
};


